import React from 'react';
import PropTypes from 'prop-types';
import TripItem from '../TripItem';
import { getTripTotal } from '../../../utils/seats';

/**
 * ClosedTripItem component.
 * Render a closed trip using the same disabled result presentation in every list.
 * @param {object} props - Closed trip presentation props.
 * @param {object} props.trip - Closed trip data.
 * @param {number} props.position - Trip position in the result list.
 * @param {Function} props.selectTrip - Trip selection callback.
 * @param {boolean} props.isRoundTrip - Whether the search is round trip.
 * @param {string} props.way - Search direction.
 * @param {boolean} props.isLogged - Whether the user is logged in.
 * @param {object} props.departureTrip - Selected departure trip for return results.
 * @param {object} props.rewardTicketStatus - Current reward ticket state.
 * @param {Function} props.setRewardTicketStatus - Reward ticket state callback.
 * @param {object} props.filtersApplied - Current result filters.
 * @param {object} props.features - Tenant feature configuration.
 * @param {object} props.origin - Selected search origin.
 * @param {object} props.destination - Selected search destination.
 * @returns {JSX.Element} Disabled trip result.
 */
const ClosedTripItem = ({
  trip,
  position,
  selectTrip,
  isRoundTrip,
  way,
  isLogged,
  departureTrip,
  rewardTicketStatus,
  setRewardTicketStatus,
  filtersApplied,
  features,
  origin,
  destination,
}) => (
  <TripItem
    trip={trip}
    id={trip.id}
    position={position}
    selectTrip={selectTrip}
    availability={0}
    isRoundTrip={isRoundTrip}
    way={way}
    isLogged={isLogged}
    departureTrip={departureTrip}
    rewardTicketStatus={rewardTicketStatus}
    setRewardTicketStatus={setRewardTicketStatus}
    total={getTripTotal({ trip, way, isRoundTrip })}
    filtersApplied={filtersApplied}
    features={features}
    origin={trip.origin || origin}
    destination={trip.destination || destination}
    arrival={trip.arrival}
    departure={trip.departure}
    duration={trip.duration}
    serviceType={trip.line?.serviceType}
    availableCategories={trip.availableCategories || []}
    isClosed
  />
);

ClosedTripItem.propTypes = {
  trip: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
  selectTrip: PropTypes.func.isRequired,
  isRoundTrip: PropTypes.bool,
  way: PropTypes.string.isRequired,
  isLogged: PropTypes.bool,
  departureTrip: PropTypes.object,
  rewardTicketStatus: PropTypes.object,
  setRewardTicketStatus: PropTypes.func,
  filtersApplied: PropTypes.object,
  features: PropTypes.object,
  origin: PropTypes.object,
  destination: PropTypes.object,
};

ClosedTripItem.defaultProps = {
  isRoundTrip: false,
  isLogged: false,
  departureTrip: null,
  rewardTicketStatus: {},
  setRewardTicketStatus: () => {},
  filtersApplied: {},
  features: {},
  origin: null,
  destination: null,
};

export default ClosedTripItem;
